import { render } from "./TheResult.vue?vue&type=template&id=10dfc081&scoped=true"
import script from "./TheResult.vue?vue&type=script&lang=js"
export * from "./TheResult.vue?vue&type=script&lang=js"

import "./TheResult.vue?vue&type=style&index=0&id=10dfc081&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10dfc081"]])

export default __exports__